import type { CommonEventProperties, SelfDescribingEvent } from '@snowplow/browser-tracker';
import { trackSelfDescribingEvent as trackSelfDescribingEventBrowser } from '@snowplow/browser-tracker';
import { trackSelfDescribingEvent as trackSelfDescribingEventWebview } from '@snowplow/webview-tracker';

import type { TrackingContextValue } from '../providers/TrackingContext';

export const trackSelfDescribingEvent = (
  event: SelfDescribingEvent & CommonEventProperties,
  context?: TrackingContextValue
) => {
  (context?.isMobileEmbedded ? trackSelfDescribingEventWebview : trackSelfDescribingEventBrowser)(
    event
  );
};
